module.exports = __webpack_public_path__ + "static/media/mk2.f4d618a7.png";